import { useMutation, useQueryClient } from "react-query";
import { useCustomQuery } from "store/hooks/react-query/query/useQuery"; 
import { request } from "utils/axios-utils";

// Hook to Fetch Records
/*
export const useGetClinicalRecords = (patientId, type) => {
  return useCustomQuery(
    ["CLINICAL_RECORDS", patientId, type],
    {
        url: `/clinical-records/${patientId}?type=${type || ""}`,
        method: "get"
    },
    {
        refetchOnWindowFocus: false,
    }
  );
};
*/

export const useGetClinicalRecords = (patientId, type, page = 1, limit = 10) => {
  return useCustomQuery(
    ["CLINICAL_RECORDS", patientId, type, page, limit], // Added dependencies to query key
    {
        url: `/clinical-records/${patientId}?type=${type || ""}&page=${page}&limit=${limit}`,
        method: "get"
    },
    {
        refetchOnWindowFocus: false,
        keepPreviousData: true, // Prevents layout shift while fetching next page
    }
  );
};

// Hook to Add Records
export const useAddClinicalRecord = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (data) => request({
      url: "/clinical-records",
      method: "post",
      data: data,
    }),
    {
      onSuccess: (_, variables) => {
        // Invalidate queries to refresh the tables
        queryClient.invalidateQueries(["CLINICAL_RECORDS", variables.patientId]);
      },
    }
  );
};

// Hook to Update Records
export const useUpdateClinicalRecord = () => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ id, data }) => request({
      url: `/clinical-records/${id}`,
      method: "put",
      data: data,
    }),
    {
      onSuccess: (_, variables) => {
        // Invalidate all records for this patient to refresh table
        queryClient.invalidateQueries(["CLINICAL_RECORDS", variables.data.patientId]);
      },
    }
  );
};

// Hook to Delete Records
export const useDeleteClinicalRecord = () => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ id }) => request({
      url: `/clinical-records/${id}`,
      method: "delete",
    }),
    {
      onSuccess: (_, variables) => {
        queryClient.invalidateQueries(["CLINICAL_RECORDS", variables.patientId]);
      },
    }
  );
};